import { useColorScheme } from 'react-native';
import Svg, { Circle, Path } from 'react-native-svg';

import { arcPath, ringArcCount, type RingSize } from '@/theme/ring';
import { darkColors, lightColors } from '@/theme/tokens.generated';

const VIEW = 24;
// Outermost radius leaves room for the stroke inside the 24 unit viewBox.
const OUTER = 10;
const STROKE_PX = 2;

// The distance ring (decision 50): 1-3 concentric brand-red arcs around a dot,
// drawn at a constant 2px stroke whatever the size. Decorative by default; pass
// `label` where the glyph is the only carrier of meaning.
export function RingGlyph({ size, arcs, label }: { size: RingSize; arcs?: 1 | 2 | 3; label?: string }) {
  const scheme = useColorScheme();
  const color = (scheme === 'dark' ? darkColors : lightColors).actionPrimary;
  const count = ringArcCount(size, arcs);
  const stroke = (STROKE_PX * VIEW) / size;
  const gap = (OUTER - stroke) / count;
  const radii = Array.from({ length: count }, (_, i) => OUTER - i * gap).filter((r) => r > stroke * 1.2);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={`0 0 ${VIEW} ${VIEW}`}
      accessible={label !== undefined}
      accessibilityLabel={label}
      aria-hidden={label === undefined}
    >
      {radii.map((r) => (
        <Path key={r} d={arcPath(VIEW / 2, r)} fill="none" stroke={color} strokeWidth={stroke} strokeLinecap="round" />
      ))}
      <Circle cx={VIEW / 2} cy={VIEW / 2} r={stroke * 0.9} fill={color} />
    </Svg>
  );
}
